var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215.03 69.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.39,68.31C6.45,59,6.45,44.93,6.45,34.64c0-5.2,0-12.9-.1-17.42A40,40,0,0,0,0,9V8.76L30.79,0h.86C30.5,9.24,30.5,24.34,30.5,34.64s0,24.34,1.06,33.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64.85,37.14l-.48-.1c-1.26,2.89-3.56,3.85-8.57,4.14C44,41.85,35.5,36.56,35.5,22.9,35.5,9,40.12,0,60.81,0,78.12,0,89.48,4,89.48,33.77c0,31.65-10.59,35.5-28.29,35.5-12.6,0-25.3-1.35-25.3-12.89C35.89,47.91,37.52,43,48.3,43a42.45,42.45,0,0,1,14,2.21c-2,11.74-2,21.36,0,21.36C64.94,66.58,65.42,45.22,64.85,37.14ZM62,1.92c-1.35,0-1.64,4.62-1.64,19.25,0,14.14.29,16.64,1.64,16.64,1.06,0,1.73-2.4,1.73-16.64C63.69,8.56,63.31,1.92,62,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M124.21,68.31c.38-3.75.67-8.37,1-13.18-10.2,0-22.7,0-31.27.38V44.35h-.09l.09-.09v-.2h.2c10.67-11.16,25.2-33,30.11-43.1h26.17c-1.06,9.33-1.06,23.38-1.06,33.68v9.62c2.4-.1,4.81-.2,7.41-.29V55.42c-2.5-.1-4.91-.2-7.22-.2.19,4.72.48,9.34.87,13.09Zm1.06-23.86V34.64c0-6.64,0-14.92-.29-22.42-2.31,1.63-5.2,12.7-5.39,32.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.14,34.06C159.14,13.47,163.37,0,187.32,0,211.09,0,215,13.47,215,34.06c0,20.39-3.94,35.21-27.8,35.21S159.14,54,159.14,34.06Zm29.92-.39c0-29.82,0-31.65-1.93-31.65s-2,1.83-2,31.65c0,30.79.1,33.58,2,33.68S189.06,64.46,189.06,33.67Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6);
export default __webpack_public_path__ + "static/media/6.a0b05c19b1e221889393f917a7495142.svg";
export { ForwardRef as ReactComponent };